import { Table } from 'components/core-v2'
import { formatCurrencyFull } from 'utilities/currency'

import { ApiOperationBase } from '@/api'

import { COLUMN_DEFS, DEFAULT_COLUMN_OPTIONS } from './columns'

export const GenericEventAssetsTable = ({ operation }: { operation: ApiOperationBase }) => {
  const rowData =
    operation.orders?.length > 0
      ? operation.orders
          ?.map(order =>
            order.legs.map(leg => {
              const isConfirmed = leg.state === 'Confirmed'

              let units = null
              if (leg.direction === 'Redemption') {
                units = leg.shares
              } else if (isConfirmed) {
                units = leg.contractNote.confirmedShares
              }

              return {
                ...leg,
                units,
                amount: isConfirmed ? leg.contractNote.confirmedValue : leg.estimatedValue,
                exeDate: isConfirmed ? leg.contractNote.executedDate : '–',
                exePrice: isConfirmed
                  ? formatCurrencyFull(leg.contractNote.executedPrice, 'ZAR')
                  : '–'
              }
            })
          )
          .flat()
      : []

  return (
    <Table
      showGreyHeader
      agGridProps={{
        columnDefs: COLUMN_DEFS,
        defaultColDef: DEFAULT_COLUMN_OPTIONS,
        headerHeight: 60,
        rowData,
        rowHeight: 44
      }}
      height="400px"
    />
  )
}
